/**
 * Account activities directive
 * Version 1.0
 * Octave
 */
(function () {
  'use strict';

  angular
    .module('directive.account-activities', [])

    /* @ngInject */
    .directive('accountActivities', function () {
      return {
        restrict: 'E',
        bindToController: {
          activitiesJson: '<',
          formData: '='
        },
        controllerAs: 'activitiesCtrl',
        /* @ngInject */
        controller: ["$element", "$timeout", function ($element, $timeout) {
          var ctrl = this;

          ctrl.$onInit = function () {
            refreshSelects();
          };

          ctrl.initActivity = function (IDActivity) {
            $timeout(function () {
              ctrl.formData.IDActivity = IDActivity.toString();

              ctrl.activities = _.find(ctrl.activitiesJson, {
                Activities: [{
                  IDActivity: Number(ctrl.formData.IDActivity)
                }]
              });

              ctrl.formData.IDActivityDomain = ctrl.activities.IDActivityDomain.toString();

              refreshSelects();
            });

          };

          ctrl.domainSelected = function () {
            if (ctrl.formData.IDActivityDomain) {
              ctrl.activities = _.find(ctrl.activitiesJson, { IDActivityDomain: Number(ctrl.formData.IDActivityDomain) });
              refreshSelects();
            }
          };

          function refreshSelects() {
            setTimeout(function () {
              $element.find('select').each(function (index, el) {
                $(el).selectpicker('refresh');
              });
            });
          }
        }]
      };
    });

})();
